
export default {
  name: 'BaseContentBlockOrderListItem',
  props: {
    item: {
      type: Object,
      default: null,
    },
  },
  methods: {
    cleanNbsp(text) {
      return text?.replace(/&nbsp;/g, ' ').trim()
    },
  },
}
